// Generated using scripts/write-decode-map.ts
// prettier-ignore
export default new Uint16Array([512, 97, 103, 108, 113, 9, 21, 24, 27, 621, 15, 0, 0, 18, 112, 59, 16422, 111, 115, 59, 16423, 116, 59, 16446, 116, 59, 16444, 117, 111, 116, 59, 16418]);
//# sourceMappingURL=decode-data-xml.js.map